/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: e7a037903731
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  UploadMappingMutationResponse,
  UploadMappingMutationResponse$zodSchema,
} from "./uploadmappingmutationresponse.js";

export type DeleteUploadMappingGlobals = { cloud_name?: string | undefined };

export const DeleteUploadMappingGlobals$zodSchema: z.ZodType<
  DeleteUploadMappingGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DeleteUploadMappingRequest = { folder: string };

export const DeleteUploadMappingRequest$zodSchema: z.ZodType<
  DeleteUploadMappingRequest
> = z.object({
  folder: z.string().describe("The folder name of the mapping to delete"),
});

export type DeleteUploadMappingResponse =
  | UploadMappingMutationResponse
  | ApiError;

export const DeleteUploadMappingResponse$zodSchema: z.ZodType<
  DeleteUploadMappingResponse
> = z.union([
  UploadMappingMutationResponse$zodSchema,
  ApiError$zodSchema,
]);
